import styled from 'styled-components';

import { heading } from '@constants/fonts';

import blueBanner from '@images/blue-banner.svg';

export const NoRecordsWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 30px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.primary}36;
  font-size: 35px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 20pt;
  }
`;

export const Spacer = styled.div`
  width: 100%;
  display: block;
  clear: both;
  height: 20px;
`;

export const MarginDiv = styled.div`
  width: 100%;
  display: block;
  clear: both;
  margin: 20px 0px;
`;

export const WrapperDiv = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

export const MainContainer = styled.div<{ height?: string }>`
  width: 100%;
  height: 87%;
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0 50px;
  flex-wrap: wrap;
  box-sizing: border-box;
  ${(props) => (props.height ? `height: ${props.height};` : '')}

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: 0;
    padding: 0;
    flex-wrap: wrap;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 0;
  }
`;

export const BigTitle = styled.div<{ fontSize?: number }>`
  width: 90%;
  font-weight: 700;
  padding: 15px 0 15px 25px;
  text-align: left;
  font-family: ${heading};
  word-break: break-word;
  font-size: ${(props) =>
    props.fontSize ? `${props.fontSize}px` : `calc((36vw - 4.5rem) / 7)`};
  color: ${(props) => props.color ?? props.theme.palette.gradient.contrastText};

  ${(props) => props.theme.breakpoints.up('xl')} {
    font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : `72px`)};
  }

  ${(props) => props.theme.breakpoints.down('lg')} {
    font-size: ${(props) =>
      props.fontSize
        ? `${props.fontSize}px`
        : `calc((20vw + 20vh + 2.5rem) / 9);`};
  }

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: 0 0 0 0;
    font-size: ${(props) =>
      props.fontSize ? `${props.fontSize}px` : `calc((69vw - 4.5rem) / 7);`};
    text-align: center;
    /* margin-bottom: calc(3vw + 25px); */
  }

  ${(props) => props.theme.breakpoints.down(520)} {
    font-size: ${(props) =>
      props.fontSize ? `${props.fontSize}px` : `calc((70vw - 38px) / 7);`};
  }
`;

export const BigTitleWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: auto 0;
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.palette.primary.light} 0%,
    ${(props) => props.theme.palette.primary.dark} 100%
  );
  /* background-image: url(${blueBanner});
  background-size: 100% auto;
  background-repeat: no-repeat; */
  /* padding-bottom: 20px; */
  /* ${(props) => props.theme.breakpoints.down('sm')} {
    width: 150%;
    margin-bottom: calc(3vw + 50px);
  } */
`;
